import productMessageBannerTemplate from './product-message-banner.tpl.html';
import './product-message-banner.less';

const PRODUCT_BANNER_MODES = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  error: 'danger',
};

export const productMessageBannerComponentModule = angular
  .module('Q.components.product-message-banner', [])

  .factory('productMessageBannerService', function () {
    const svc = {
      $onChange: angular.noop,
      message: null,
      show,
      showInfo: show.bind(null, 'info'),
      showSuccess: show.bind(null, 'success'),
      showWarning: show.bind(null, 'warning'),
      showDanger: show.bind(null, 'danger'),
      hide() {
        svc.message = null;
        svc.$onChange();
      },
      get active() {
        return !!svc.message;
      },
    };

    function show(
      mode,
      message,
      { link, linkTitle, linkAction, closeable = true, icon } = {},
    ) {
      svc.mode = PRODUCT_BANNER_MODES[mode] || mode.info;
      svc.icon = icon;
      svc.message = message;
      svc.link = link;
      svc.linkTitle = linkTitle;
      svc.linkAction = linkAction || angular.noop;
      svc.closeable = closeable;
      svc.$onChange();
    }

    return svc;
  })

  .component('productMessageBanner', {
    controller: 'ProductMessageBannerCtrl',
    template: productMessageBannerTemplate,
  })

  .controller(
    'ProductMessageBannerCtrl',
    function ProductMessageBannerCtrl($element, productMessageBannerService) {
      const ctrl = this;

      ctrl.service = productMessageBannerService;

      function update() {
        ['info', 'success', 'warning', 'danger'].forEach((mode) => {
          $element.removeClass('alert-' + mode);
        });
        const active = productMessageBannerService.active;
        $element.toggleClass('active', active);
        $element.parent().toggleClass('has-product-message-banner', active);
        if (active) {
          // preserves the rendered message on hide
          ctrl.message = productMessageBannerService.message;
          $element.addClass('alert-' + productMessageBannerService.mode);
        }
      }

      ctrl.$onInit = () => {
        $element.addClass('alert');
      };

      productMessageBannerService.$onChange = update;

      ctrl.$postLink = update;
    },
  );
